import {
  PRODUCT_CATEGORY_FORM_MESSAGES,
  ProductCategoryFormMessages,
} from "./product-categories-form.messages";
import { ACTION_BUTTON_MESSAGES, ActionButtonMessages } from "../action-buttons.messages";
import { SIDEBAR_MESSAGES, SidebarMessages } from "../layout/sidebar";

export type ProductCategoryFormPageMessages = ActionButtonMessages &
  ProductCategoryFormMessages &
  SidebarMessages & {
    updatePageTitle: string;
    createPageTitle: string;
    createCategoryCardTitle: string;
    breadCrumbTitle: string;
  };

export const PRODUCT_CATEGORY_DETAILS_MESSAGES: ProductCategoryFormPageMessages = {
  // Page titles
  breadCrumbTitle: "Categorias",
  updatePageTitle: "Detalhes da Categoria",
  createPageTitle: "Criar Categoria",
  createCategoryCardTitle: "Nova categoria",

  ...PRODUCT_CATEGORY_FORM_MESSAGES,
  ...ACTION_BUTTON_MESSAGES,
  ...SIDEBAR_MESSAGES,
};
